module.exports = __webpack_public_path__ + "static/media/ghost.90be98d6.jpg";